import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { loadingOverlay } from "vuetify-more-component";
export default {
  components: {
    loadingOverlay
  },

  data() {
    return {
      loading: false,
      search: "",
      datos_tabla: [],
      dialog_filtro: false,
      filtro_fecha: {
        fecha_inicio: null,
        fecha_fin: null
      },
      selectedOptionNIT: "",
      headers: [
        { text: "Nit", value: "nit" },
        { text: "Nombre", value: "usuario_id" },
        { text: "Regimen", value: "regimen_id" },
        { text: "Mes", value: "mes" },
        { text: "Año", value: "anio" },
        { text: "Estado", value: "estado" },
        { text: "Fecha Transaccion", value: "fecha_transaccion" },
        { text: "Fecha Maxima Sol.", value: "fecha_maxima_sol_archivo" },
        { text: "Archivo", value: "tipo_archivo_id" }
      ],
      filtro_tipo_archivos: {
        tipo_archivos: [
          { text: "Todos", value: 0 },
          { text: "Retención IVA", value: 3 },
          { text: "Retención ISR", value: 4 },
          { text: "Generación Factura", value: 9 },
          { text: "Facturas Recibidas", value: 2 },
          { text: "Facturas Emitidas", value: 1 },
          { text: "Declaración IVA Pequeño Contribuyente", value: 5 },
          { text: "Declaración IVA General", value: 6 },
          { text: "Declaración ISR", value: 7 },
          { text: "Consulta Declaración", value: 8 }
        ]
      },
      selectedTipoArchivo: 0 // Variable para almacenar la selección del v-select
    };
  },
  async created() {
    console.log("/massive_reporte");

    // this.filtro_fecha.fecha_inicio = primer dia del mes
    const currentDate = new Date();
    this.filtro_fecha.fecha_inicio =
      currentDate.getMonth() + 1 + "-" + "1-" + currentDate.getFullYear();

    // this.filtro_fecha.fecha_fin = ultimo dia del mes
    const lastDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    this.filtro_fecha.fecha_fin =
      currentDate.getMonth() +
      1 +
      "-" +
      lastDay.getDate() +
      "-" +
      currentDate.getFullYear();

    await this.getUsuarios();
  },
  computed: {
    dateRule() {
      return (v) => !!v || "Fecha requerida";
    }
  },
  methods: {
    formatDate(date) {
      console.log("formatDate", date);
      if (!date) return "";
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    async getUsuarios() {
      console.log("getUsuarios");
      this.loading = true;

      let fecha_inicio = this.filtro_fecha.fecha_inicio.split("-");
      console.log("Fecha i: ", fecha_inicio);
      let fecha_fin = this.filtro_fecha.fecha_fin.split("-");
      console.log("Fecha f: ", fecha_fin);
      this.filtro_fecha.fecha_inicio =
        fecha_inicio[2] + "-" + fecha_inicio[0] + "-" + fecha_inicio[1];
      this.filtro_fecha.fecha_fin =
        fecha_fin[2] + "-" + fecha_fin[0] + "-" + fecha_fin[1];

      console.log(
        "Fecha a iniciar el reporte: ",
        this.filtro_fecha.fecha_inicio
      );
      console.log(
        "Fecha a finalizar el reporte: ",
        this.filtro_fecha.fecha_fin
      );
      console.log("NIT: ", this.selectedOptionNIT);
      console.log("Tipo Archivo id: ", this.selectedTipoArchivo);

      try {
        let reporteMasivo =
          await this.$store.state.services.reportesService.reporteMasivo(
            this.filtro_fecha.fecha_inicio,
            this.filtro_fecha.fecha_fin,
            this.selectedOptionNIT,
            this.selectedTipoArchivo
          );
        console.log("reporteMasivo", reporteMasivo);

        const formattedData = await this.Format_data(reporteMasivo.data.data);
        this.datos_tabla = formattedData;
      } catch (error) {
        console.log(error);
        this.$toast.warning("No es posible procesar la información");
      }

      this.filtro_fecha.fecha_inicio =
        fecha_inicio[0] + "-" + fecha_inicio[1] + "-" + fecha_inicio[2];
      this.filtro_fecha.fecha_fin =
        fecha_fin[0] + "-" + fecha_fin[1] + "-" + fecha_fin[2];

      this.loading = false;
    },
    async Format_data(data) {
      console.log("Format_data", data);
      try {

        // Formatea los datos
        data = data.map((item) => {

          console.log('item',item);
          console.log('item.tipo_archivo_id',item.tipo_archivo_id);

          let tipo_archivo = this.filtro_tipo_archivos.tipo_archivos.find(
            (items) => items.value === item.tipo_archivo_id
          ).text;

          console.log('tipo_archivo',tipo_archivo);

          if (item.mes === 1) {
            item.mes = "Enero";
          } else if (item.mes === 2) {
            item.mes = "Febrero";
          } else if (item.mes === 3) {
            item.mes = "Marzo";
          } else if (item.mes === 4) {
            item.mes = "Abril";
          } else if (item.mes === 5) {
            item.mes = "Mayo";
          } else if (item.mes === 6) {
            item.mes = "Junio";
          } else if (item.mes === 7) {
            item.mes = "Julio";
          } else if (item.mes === 8) {
            item.mes = "Agosto";
          } else if (item.mes === 9) {
            item.mes = "Septiembre";
          } else if (item.mes === 10) {
            item.mes = "Octubre";
          } else if (item.mes === 11) {
            item.mes = "Noviembre";
          } else if (item.mes === 12) {
            item.mes = "Diciembre";
          }

          if (item.estado === 'S') {
            item.estado = "Solicitado";
          } else if (item.estado === 'P') {
            item.estado = "Procesado";
          }

          try {
            return {
              nit: item.nit,
              usuario_id:
                item.usuarios[0].primer_nombre +
                " " +
                item.usuarios[0].primer_apellido,
              regimen_id: item.usuarios[0].regimen.descripcion,
              mes: item.mes,
              anio: item.anio,
              estado: item.estado,
              fecha_maxima_sol_archivo: new Date(
                item.fecha_maxima_sol_archivo
              ).toLocaleDateString(),
              fecha_transaccion: new Date(
                item.fecha_transaccion
              ).toLocaleDateString(),
              tipo_archivo_id: tipo_archivo
            };

          } catch (e) {
            console.log(e);

            return {
              nit: item.nit,
              usuario_id: item.usuarios && item.usuarios.length > 0
                ? item.usuarios[0].primer_nombre + " " + item.usuarios[0].primer_apellido
                : "Desconocido", // Valor predeterminado si no hay usuarios
              regimen_id: item.usuarios && item.usuarios.length > 0
                ? item.usuarios[0].regimen.descripcion
                : "Desconocido", // Valor predeterminado si no hay usuarios
              mes: item.mes,
              anio: item.anio,
              estado: item.estado,
              fecha_maxima_sol_archivo: item.fecha_maxima_sol_archivo
                ? new Date(item.fecha_maxima_sol_archivo).toLocaleDateString()
                : "Fecha no disponible", // Valor predeterminado si la fecha no está disponible
              fecha_transaccion: item.fecha_transaccion
                ? new Date(item.fecha_transaccion).toLocaleDateString()
                : "Fecha no disponible", // Valor predeterminado si la fecha no está disponible
              tipo_archivo_id: tipo_archivo && tipo_archivo.text ? tipo_archivo.text : "Tipo no disponible" // Valor predeterminado si tipo_archivo o tipo_archivo.text no están presentes
            };

          }
        });

        return data;
      } catch (e) {
        console.log(e);
      }
    },
    filtra_tabla() {
      this.filtro_fecha.fecha_inicio = this.formatDate(
        new Date(this.filtro_fecha.fecha_inicio)
      );
      this.filtro_fecha.fecha_fin = this.formatDate(
        new Date(this.filtro_fecha.fecha_fin)
      );
      this.dialog_filtro = true;
    },
    exportarExcel() {
      const ws = XLSX.utils.json_to_sheet(this.datos_tabla, {
        header: this.headers.map((header) => header.value)
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Datos");
      XLSX.writeFile(wb, "reporte_documente_sat.xlsx");
    },
    exportarPdf() {
      const doc = new jsPDF();

      autoTable(doc, {
        head: [this.headers.map((header) => header.text)],
        body: this.datos_tabla.map((item) =>
          this.headers.map((header) => item[header.value])
        )
      });

      doc.save("reporte_documento_sat.pdf");
    },
    aplicarFiltro() {
      console.log("aplicarFiltro");
      this.dialog_filtro = false;

      let fecha_inicio = this.filtro_fecha.fecha_inicio.split("-");
      let fecha_fin = this.filtro_fecha.fecha_fin.split("-");
      this.filtro_fecha.fecha_inicio =
        fecha_inicio[1] + "-" + fecha_inicio[2] + "-" + fecha_inicio[0];
      this.filtro_fecha.fecha_fin =
        fecha_fin[1] + "-" + fecha_fin[2] + "-" + fecha_fin[0];

      this.getUsuarios();
    }
  }
};
